import { defineStore } from 'pinia'

import { getOptions } from '~/features-shared/config-manager/api/tenant'
import type { ITenant, ITenantOptions } from '~/features-shared/config-manager/interfaces/swym-options'

export const useTenantStore = defineStore({
  id: 'tenant',

  state: () => ({
    nativeTenantInfo: undefined,
    options: undefined,
  } as Partial<ITenant>),

  getters: {
    tenantOptions: state => state.options,
    tenantInfo: state => state.nativeTenantInfo,
    isOptionActivated: state => (name: keyof ITenantOptions) =>
      state.options?.['X-DS-SWYM-VERSION'] === '2' && (state.options?.[name] ?? true),
  },

  actions: {
    async fetchOptions() {
      const response = await getOptions()
      if (response.result)
        this.options = response.result.options

      return response.result.options
    },

    async getOrFetchOptions(): Promise<ITenantOptions> {
      return this.options || this.fetchOptions()
    },

    setTenantInfo(tenant: any) {
      this.nativeTenantInfo = tenant
    },
  },
})
